import React, { useState } from 'react'
import { workflowList } from '../../../context/workflowContext'
import { Grid, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import workflowStyle from "../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss"; 
import workflowImg from "../../../assets/images/workflow/defaultWorkFlowIcon.svg"; 
import MoreVertIcon from '@mui/icons-material/MoreVert';
import globalStyles from "../../../assets/styles/global.module.scss";
import { getChatbotListNewReponseModel } from '../../../models/axiosModel';
import { useNavigate } from 'react-router-dom';

interface WorkflowGridCardProps {
    list: getChatbotListNewReponseModel,
    anchorEl: HTMLElement | null,
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
    currentRowIndex: number | string | null,
    setCurrentRowIndex: React.Dispatch<React.SetStateAction<string | number | null>>,
    handleMenuOpen: (event: React.MouseEvent<HTMLElement, MouseEvent>, rowIndex: number | string, list: any ) => void,
    handleMenuClose: () => void,
    setFlagDeleteWorkflowPopup: React.Dispatch<React.SetStateAction<boolean>>, 
    workflowActionMenuItem: {
        label: string;
        icon: JSX.Element;
        action: (list: any) => void;
        isDisabled: boolean;
    }[],
}  

const WorkflowGridCard: React.FC<WorkflowGridCardProps> = (props) => { 
  const navigate = useNavigate()
  const {list, anchorEl, setAnchorEl, currentRowIndex, setCurrentRowIndex, handleMenuOpen, handleMenuClose, setFlagDeleteWorkflowPopup, workflowActionMenuItem} = props;

  const handleDotColor = (list: getChatbotListNewReponseModel) => {
    switch(list.chatbot_status.chatbot_status_name.toLowerCase()){
      case "paused": 
        return "rgba(226, 162, 42, 1)"; 
      case "active": 
        return "rgba(15, 185, 21, 1)"; 
      default : 
        return "rgba(42, 165, 226, 1)"; 
    }
  }
  
  return (
    <> 
      <Grid container flexDirection={"column"} className={workflowStyle.workFlowGridmainContainer} onClick={() => { navigate(`/workflow/staticWorkflowDetails?workflow_id=${list.chatbot_id}`) }}>
          <Grid item className={workflowStyle.workFlowGridCardImgGrid}>
            <img alt="" src={workflowImg} />
          </Grid> 
          <Grid item>
              <Grid container justifyContent={"space-between"} alignItems={"center"} className={workflowStyle.workflowGridCardInfoContainer}>
                  <Grid item display={"flex"} alignItems={"center"}>
                    <Tooltip title={list.chatbot_status.chatbot_status_name} arrow placement='top'>
                      <span style={{backgroundColor: handleDotColor(list)}} className={workflowStyle.wokflowTitleDot}></span>
                    </Tooltip> 
                    <Typography className={workflowStyle.workflowGridCardTitleTypography}>{list.chatbot_name}</Typography>
                  </Grid>
                  <Grid item display={"flex"} onClick={(e) => e.stopPropagation()}>
                    <MoreVertIcon
                        sx={{ cursor: "pointer" }}
                        onClick={(e: any) => {e.stopPropagation(); handleMenuOpen(e, list.chatbot_id, list)}}
                    /> 
                    <Menu
                        anchorEl={anchorEl} 
                        keepMounted 
                        open={Boolean(anchorEl) && list.chatbot_id == currentRowIndex} 
                        onClose={handleMenuClose} 
                    > 
                        {workflowActionMenuItem.map((item, index) => {
                            return (
                                <MenuItem 
                                    className={globalStyles.menuItemStyle} 
                                    key={index} 
                                    sx={{fontSize: "14px", fontWeight: "500"}} 
                                    onClick={(e) => {e.stopPropagation(); handleMenuClose(); item.action(list)}} 
                                    disabled={item.isDisabled}
                                > 
                                    <ListItemIcon>
                                        {item.icon}
                                    </ListItemIcon> 
                                    <span>
                                        {item.label}
                                    </span>
                                </MenuItem>
                            );
                        })}
                    </Menu>
                  </Grid>
              </Grid>
          </Grid>
      </Grid>
    </>
  )
}

export default WorkflowGridCard
